module.exports = __webpack_public_path__ + "img/banner4.ec152daa.png";